// #genai Shared style for the guest-access

const FONT_FAMILY = 'Noto Sans, sans-serif';
const COLOR_DARK = '#1B202C';
const COLOR_TEXT = '#222222';

export const guestFlowBaseStyles = {
  title: {
    fontFamily: FONT_FAMILY,
    fontWeight: 300,
    fontSize: '32px',
    lineHeight: '48px',
    letterSpacing: '0%',
    color: COLOR_DARK,
    margin: 0,
    textTransform: 'none',
  },
  body: {
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0%',
    color: COLOR_TEXT,
    margin: 0,
  },
  bodySmall: {
    fontFamily: FONT_FAMILY,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0%',
    color: COLOR_TEXT,
    margin: 0,
  },
  boldText: {
    fontFamily: FONT_FAMILY,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0%',
    color: COLOR_TEXT,
  },
};

export const guestFlowThemedStyles = (theme) => ({
  actionLink: {
    fontFamily: FONT_FAMILY,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '0%',
    color: theme.evPalette.ocean[600],
    textDecoration: 'none',
    background: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  },
});
